import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  DirectionsRenderer,
} from "@react-google-maps/api";
import LocationOffIcon from "@mui/icons-material/LocationOff";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import CancelIcon from "@mui/icons-material/Cancel";
import { axios } from "../utils/axios";
import Rating from "@mui/material/Rating";
import Pins from "../assets/icons/pins.png";
import Other from "../assets/icons/otherpins.png";
import { setMapPins } from "../redux/slices/mapPins";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Modal from "./Modal";
import TextBox from "./textbox";
import { createTags } from "../redux/slices/mapPins";
import Loader from "./Loader";
import NOIMG from "../assets/icons/noImage.jpg";
const mapContainerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "6px",
};

const DirectionsMapComp = ({
  markerData,
  styles,
  zoom,
  searchLocation,
  tripId,
  showDirections,
  url,
  disablePinsMarking,
  loading,
  placeDetails,
}) => {
  const [pinnedMarkers, setPinnedMarkers] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(zoom || 17);
  const [open, setOpen] = useState(false);
  const [alltrips, setAlltrips] = useState();
  const dispatch = useDispatch();
  const [center, setCenter] = useState({
    lat: 19.055635907042102,
    lng: 72.8601093761628,
  });
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [tabId, setTabId] = useState(0);
  const [tag, setTag] = useState("");
  const [selectedId, setSelecedId] = useState("");
  const fetchDirections = (path) => {
    if (!window.google || !window.google.maps) {
      console.error("Google Maps API not loaded yet.");
      return;
    }
    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin: path?.start,
        destination: path?.end,
        waypoints: path?.waypoints,
        travelMode: window.google.maps.TravelMode.DRIVING,
        optimizeWaypoints: true,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirectionsResponse(result);
          let totalDistanceInMeters = 0;
          let distances = [];

          result.routes[0].legs.forEach((leg, index) => {
            // Add the distance for this leg
            totalDistanceInMeters += leg.distance.value;

            // Add the distance of this leg to the array
            distances.push({
              from:
                index === 0 ? path.start : path.waypoints[index - 1].location,
              to:
                path.waypoints && path.waypoints[index]
                  ? path.waypoints[index].location
                  : path.end,
              distanceInMeters: leg.distance.value,
              distanceInKilometers: (leg.distance.value / 1000).toFixed(2),
            });
          });
          setZoomLevel(17);
          const totalDistanceInMiles = totalDistanceInMeters * 0.000621371; // Convert meters to miles
        } else {
          console.error(`Error fetching directions: ${status}`);
        }
      }
    );
  };

  useEffect(() => {
    if (searchLocation && markerData && markerData?.length !== 0) {
      setCenter(searchLocation);
      setPinnedMarkers(markerData);
    } else if (markerData && markerData?.length !== 0) {
      setPinnedMarkers(markerData);
      setCenter({
        lat: markerData[0]?.lat,
        lng: markerData[0]?.lng,
      });
    } else {
      setCenter(searchLocation);
    }
    if (showDirections) {
      getFilterdLocations(markerData);
    }
  }, [markerData, searchLocation]);
  useEffect(() => {
    if (placeDetails) {
      setCenter(searchLocation);
      const newMarker = {
        tripId: tripId || null,
        lat: placeDetails?.geometry?.location?.lat(),
        lng: placeDetails?.geometry?.location?.lng(),
        name: placeDetails?.name || "Unnamed Location",
        address: placeDetails?.formatted_address || "Address not available",
        image: placeDetails?.photos?.[0].getUrl(),
        userRatings: placeDetails?.user_ratings_total,
        ratings: placeDetails?.rating,
        openingHours:
          placeDetails?.current_opening_hours?.open_now === true
            ? "Open Now"
            : "Closed" || " ",
        _id: "",
      };
      setSelectedMarker(newMarker);
      setZoomLevel(17);
    }
  }, [placeDetails]);
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND + "pins/getalltags")
      .then((resp) => {
        setAlltrips(resp.data.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const getFilterdLocations = (markerData) => {
    const filteredLocations = markerData.filter(
      (location) => location.tripStatus === true
    );
    if (filteredLocations.length > 1) {
      let path = {
        start: {
          lat: filteredLocations[0]?.lat,
          lng: filteredLocations[0]?.lng,
        },
        waypoints: filteredLocations
          .slice(1, filteredLocations.length - 1)
          .map((location) => ({
            location: { lat: location?.lat, lng: location?.lng },
          })),
        end: {
          lat: filteredLocations[filteredLocations.length - 1]?.lat,
          lng: filteredLocations[filteredLocations.length - 1]?.lng,
        },
      };

      fetchDirections(path);
    }
  };
  const handleMapClick = async (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    const latLng = { lat, lng };
    let placeId = "";
    const service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
        placeId = results[0].place_id;
        service.getDetails({ placeId }, (placeDetails, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            placeDetails
          ) {
            const newMarker = {
              tripId: tripId || null,
              lat: placeDetails?.geometry?.location?.lat(),
              lng: placeDetails?.geometry?.location?.lng(),
              name: placeDetails?.name || "Unnamed Location",
              address:
                placeDetails?.formatted_address || "Address not available",
              image: placeDetails?.photos?.[0].getUrl() || "",
              userRatings: placeDetails?.user_ratings_total,
              ratings: placeDetails?.rating,
              openingHours:
                placeDetails?.current_opening_hours?.open_now === true
                  ? "Open Now"
                  : "Closed" || " ",
              _id: "",
            };
            setSelectedMarker(newMarker);
          }
        });
      } else {
        console.error("Geocoder failed due to: " + status);
      }
    });
  };

  const handleMarkerClick = (marker) => {
    setSelectedMarker(marker);
  };

  const handleUnpin = (marker) => {
    setPinnedMarkers((prev) =>
      prev.filter((m) => m.lat !== marker.lat || m.lng !== marker.lng)
    );
    removePins(marker._id);
    setSelectedMarker(null);
  };

  const addPins = (data) => {
    axios
      .post(process.env.REACT_APP_BACKEND + "pins/addpin", data)
      .then((resp) => {
        setPinnedMarkers(resp.data.data.allPins);
        dispatch(setMapPins(resp.data.data.allPins));
        getFilterdLocations(resp.data.data.allPins);
        setSelectedMarker(null);
        setSelecedId(resp?.data?.data?.latestPinId);
        setOpen(true);
      })
      .catch((err) => {
        console.log(err);
        toast.error("SignUp/Login to pin a location");
      });
  };
  const removePins = (id) => {
    axios
      .delete(
        process.env.REACT_APP_BACKEND +
          `pins/removepin?id=${id}&tripid=${tripId || ""}`
      )
      .then((resp) => {
        setPinnedMarkers(resp.data.data);
        dispatch(setMapPins(resp.data.data));
        getFilterdLocations(resp.data.data);
      })
      .catch((err) => console.log(err));
  };
  const handleAddToTrip = (id) => {
    axios
      .post(process.env.REACT_APP_BACKEND + `pins/addpintotrip`, {
        tripId: tripId,
        id: id._id,
        tripStatus: true,
      })
      .then((resp) => {
        setPinnedMarkers(resp.data.data);
        dispatch(setMapPins(resp.data.data));
        getFilterdLocations(resp.data.data);
        setSelectedMarker(null);
      })
      .catch((err) => console.log(err));
  };
  const handleAddToTripFromHome = (id) => {
    axios
      .post(process.env.REACT_APP_BACKEND + `pins/addpintotag`, {
        pinId: selectedId,

        tagId: id._id,
      })
      .then((resp) => {
        // setPinnedMarkers(resp.data.data);
        // dispatch(setMapPins(resp.data.data));
        // getFilterdLocations(resp.data.data);
        setSelecedId("");
        setOpen(false);
        // setZoomLevel(17);
        setSelectedMarker(null);
        toast.success("Location added successfully");
      })
      .catch((err) => console.log(err));
  };
  const createTag = async () => {
    const resp = await dispatch(createTags({ data: { name: tag } }));
    if (resp.payload) {
      setAlltrips(resp.payload);
      setTag("");
      setTabId(0);
    }
  };
  return (
    <>
      {loading && <Loader />}
      <GoogleMap
        mapContainerStyle={{ ...mapContainerStyle, ...styles }}
        center={center}
        zoom={zoomLevel}
        onClick={handleMapClick}
        options={{
          clickableIcons: false,
          fullscreenControl: false,
        }}
      >
        {pinnedMarkers.map((marker, index) => (
          <Marker
            key={index}
            position={{ lat: marker.lat, lng: marker.lng }}
            onClick={() => handleMarkerClick(marker)}
            animation={window.google.maps.Animation.DROP}
            icon={
              marker.tripStatus
                ? {
                    url: Pins, // Use your custom image as the pin
                    scaledSize: new window.google.maps.Size(30, 40), // Adjust the size of the custom marker
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(15, 40),
                  }
                : marker?.category
                ? {
                    url: Other, // Use your custom image as the pin
                    scaledSize: new window.google.maps.Size(30, 40), // Adjust the size of the custom marker
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(15, 40),
                  }
                : undefined // Use the default marker if no condition is met
            }
            label={
              marker.number
                ? {
                    text: String(marker.number), // Display the number if it exists
                    color: "black",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }
                : undefined // No label if number is not present
            }
          />
        ))}
        {selectedMarker && (
          <InfoWindow
            position={{
              lat: selectedMarker.lat,
              lng: selectedMarker.lng,
            }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div>
              <h3>{selectedMarker?.name}</h3>
              <p>{selectedMarker?.address}</p>
              <div style={{ height: "15vh" }}>
                <img
                  src={selectedMarker?.image || NOIMG}
                  alt="Pinned location"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                  loading="lazy"
                />
              </div>
              {/* {selectedMarker?.openingHours !== "" &&
                selectedMarker?.openingHours !== undefined && (
                  <p className="mt-3"> {selectedMarker?.openingHours}</p>
                )} */}
              {/* {selectedMarker?.userRatings && (
                <p>User ratings:- {selectedMarker?.userRatings}</p>
              )} */}
              {selectedMarker?.ratings && (
                // <p> Ratings:- {selectedMarker?.ratings}</p>
                <Rating
                  name="read-only"
                  value={selectedMarker?.ratings}
                  readOnly
                />
              )}

              <div style={{ textAlign: "end" }}>
                {disablePinsMarking === false && (
                  <>
                    {selectedMarker && selectedMarker?._id === "" ? (
                      <>
                        <button
                          className="icon-btn"
                          onClick={() => addPins(selectedMarker)}
                          style={{ color: "var(--primary-color)" }}
                        >
                          <LocationOnIcon />
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="icon-btn"
                          onClick={() => handleUnpin(selectedMarker)}
                          style={{ color: "#ea4335" }}
                        >
                          <LocationOffIcon />
                        </button>
                        {/* <button
                          className="icon-btn"
                          onClick={() => openPopUp(selectedMarker)}
                          style={{ color: "var(--primary-color)" }}
                        >
                          <AddToPhotosIcon />
                        </button> */}
                      </>
                    )}
                    {selectedMarker?.tripStatus === false && url !== "/" && (
                      <button
                        className="icon-btn"
                        onClick={() => handleAddToTrip(selectedMarker)}
                        style={{ color: "var(--primary-color)" }}
                      >
                        <AddLocationIcon />
                      </button>
                    )}
                  </>
                )}
                <button
                  className="icon-btn"
                  onClick={() => setSelectedMarker(null)}
                  style={{ color: "#ea4335" }}
                >
                  <CancelIcon />
                </button>
              </div>
            </div>
          </InfoWindow>
        )}

        {directionsResponse && (
          <DirectionsRenderer
            directions={directionsResponse}
            options={{ suppressMarkers: true }}
          />
        )}
      </GoogleMap>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setTabId(0);
        }}
        title="Add to Tag"
        size="sm"
      >
        {tabId === 0 && (
          <>
            <div className="d-flex " style={{ gap: "20px", flexWrap: "wrap" }}>
              {alltrips &&
                alltrips.map((trip, index) => (
                  <div
                    style={{
                      border: "1px solid var(--light-grey)",
                      padding: "2px 10px",
                      borderRadius: "50px",
                      fontSize: "14px",
                      width: "fit-content",
                    }}
                    key={index}
                    className=" c-pointer d-flex align-items-center pin-hover-home"
                    onClick={() => handleAddToTripFromHome(trip)}
                  >
                    <p>{trip.name}</p>
                  </div>
                ))}
            </div>
            <div style={{ textAlign: "center" }}>
              <button
                className="btn-contained mt-3"
                onClick={() => setTabId(1)}
              >
                Create New Tag
              </button>
            </div>
          </>
        )}
        {tabId === 1 && (
          <div className="t-center">
            <TextBox
              type="text"
              placeholder="Enter Tag Name"
              name="lastName"
              value={tag}
              onChange={(e) => setTag(e.target.value)}
            />
            <button className="btn-contained mt-3  mb-3" onClick={createTag}>
              Submit
            </button>
          </div>
        )}
      </Modal>
    </>
  );
};

export default DirectionsMapComp;
